function isCurrentContextLink(currentContext, expectedType, expectedId) {
  return (
    currentContext &&
    currentContext.type === expectedType &&
    currentContext.id &&
    currentContext.id === expectedId
  );
}

export function getActivityContextLinks(activity, { currentContext = null } = {}) {
  if (!activity) return [];

  const links = [];
  if (activity.related_deal_id && !isCurrentContextLink(currentContext, "deal", activity.related_deal_id)) {
    links.push({ label: "Deal öffnen", to: `/deals/${activity.related_deal_id}` });
  }
  if (activity.related_lead_id && !isCurrentContextLink(currentContext, "lead", activity.related_lead_id)) {
    links.push({ label: "Lead öffnen", to: `/leads/${activity.related_lead_id}` });
  }
  if (
    activity.related_company_id &&
    !isCurrentContextLink(currentContext, "company", activity.related_company_id)
  ) {
    links.push({ label: "Firma öffnen", to: `/firmen/${activity.related_company_id}` });
  }
  if (
    activity.related_contact_id &&
    !isCurrentContextLink(currentContext, "contact", activity.related_contact_id)
  ) {
    links.push({ label: "Kontakt öffnen", to: `/kontakte/${activity.related_contact_id}` });
  }
  if (
    activity.related_task_id &&
    !isCurrentContextLink(currentContext, "task", activity.related_task_id)
  ) {
    links.push({ label: "Aufgabe öffnen", to: `/aufgaben/${activity.related_task_id}` });
  }
  return links;
}
